// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:43:10

export default {
  "id": "hangman-saga",
  "slug": "hangman-saga",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/993f0291d0734140aa6fa5a5dd6ad7b9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/993f0291d0734140aa6fa5a5dd6ad7b9/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Hangman Saga",
      "description": "Challenge your vocabulary with Hangman Saga! With thousands of levels, each word includes a category hint to guide you—like \"Profession\" for \"Doctor.\" Guess the letters wisely, but too many mistakes end the game! Need help? Use the hint button for a clue. Perfect for all ages, this fun and educational word puzzle will keep you entertained while sharpening your spelling skills. Can you solve them all?",
      "instructions": "Use a mouse or touchpad to tap the letters, guess the words, and fill in the blanks to complete the word.",
      "genres": [
        "Educational",
        "Puzzle"
      ],
      "tags": [
        "hangman",
        "spelling",
        "thinking",
        "trivia",
        "wordscapes"
      ]
    },
    "zh-CN": {
      "title": "吊车人传奇",
      "description": "挑战你的词汇量，玩Hangman Saga！成千上万的关卡，每个单词都包含一个类别提示来引导你——比如“Doctor”的提示是“职业”。明智地猜测字母，但过多的错误会导致游戏结束！需要帮助？使用提示按钮获取线索。适合所有年龄，这个有趣且富有教育性的文字谜题将让你在娱乐的同时提高拼写技巧。你能全部解决吗？",
      "instructions": "使用鼠标或触摸板点击字母，猜测单词，并填写空格以完成单词。",
      "genres": [
        "教育",
        "谜题"
      ],
      "tags": [
        "猜字谜",
        "拼写",
        "思考",
        "知识问答",
        "拼字游戏"
      ]
    },
    "zh-TW": {
      "title": "懸吊人傳說",
      "description": "挑戰你的詞彙能力，與Hangman Saga一決高下！超過千個關卡，每個單詞都包含一個類別提示來引導你——像是「職業」對應「醫生。」智慧地猜測字母，但太多的錯誤會結束遊戲！需要幫助？使用提示按鈕來獲得線索。適合所有年齡層，這個有趣且富有教育性的單詞謎題將讓你歡樂同時練習你的拼寫技巧。你能解決所有關卡嗎？",
      "instructions": "使用滑鼠或觸控板點擊字母，猜測單詞，並填入空白處以完成詞語。",
      "genres": [
        "教育性",
        "謎題"
      ],
      "tags": [
        "吊死鬼",
        "拼字",
        "思考",
        "猜謎",
        "單字拼圖"
      ]
    },
    "zh-HK": {
      "title": "懸命傳奇",
      "description": "挑戰你的詞彙能力，玩《Hangman Saga》！有數千個關卡，每個單詞都包含一個類別提示來引導你——例如，“職業”對應“醫生。”明智地猜測字母，但犯太多錯誤就會結束遊戲！需要幫助？使用提示按鈕來獲得線索。適合所有年齡層，這個有趣且富有教育性的文字謎題將讓你保持娛樂並提升你的拼寫技巧。你能解開所有謎題嗎？",
      "instructions": "使用滑鼠或觸控板輕觸字母，猜測單詞，填入空格以完成詞語。",
      "genres": [
        "教育性",
        "謎題"
      ],
      "tags": [
        "懸掛人",
        "拼字",
        "思考",
        "趣味問答",
        "單詞風景"
      ]
    },
    "ja": {
      "title": "ハングマンサーガ",
      "description": "Hangman Sagaであなたの語彙力に挑戦しましょう！何千レベルにわたって、それぞれの単語には「職業」のようにカテゴリーハントが含まれており、あなたを導きます。正確に文字を推測してくださいが、多くのミスをするとゲームが終わります！助けが必要ですか？ヒントボタンを使って手がかりを得ましょう。どの世代にも適した、楽しい学習パズルで、スペル力を鍛えることができます。すべてを解けるかな？",
      "instructions": "マウスやタッチパッドを使用して、文字をタップし、単語を推測し、空白を埋めて単語を完成させます。",
      "genres": [
        "教育的",
        "パズル"
      ],
      "tags": [
        "ハングマントリックス",
        "スペル",
        "思考",
        "クイズ",
        "ワードスカイプ"
      ]
    },
    "ko": {
      "title": "링고사가",
      "description": "한문자말 사가와 어휘력을 도전하세요! 수천 개의 레벨이 있는 이 게임에서, 각 단어에는 카테고리 힌트가 포함되어 있습니다—예를 들어 \"Doctor\"의 경우 \"Profession\"입니다. 알파벳을 지혜롭게 맞추세요만, 너무 많은 실수로는 게임이 끝납니다! 도움이 필요하시면 힌트 버튼을 사용하세요. 모든 연령대에게 적합한 이 재미있고 교육적인 단어 퍼즐은 스펠링 기술을 훈련하면서도 즐거움을 제공합니다. 모든 것을 풀 수 있을까요?",
      "instructions": "마우스나 터치패드를 사용하여 글자를 탭하고 단어를 추측하고 공백을 채워 단어를 완성하세요.",
      "genres": [
        "교육용",
        "퍼즐"
      ],
      "tags": [
        "형맨",
        "발음",
        "생각",
        "퀴즈",
        "워드스케이프"
      ]
    },
    "fr": {
      "title": "Saga de l'Échafaud",
      "description": "Défiez votre vocabulaire avec Hangman Saga ! Avec des milliers de niveaux, chaque mot inclut un indice de catégorie pour vous guider - comme \"Profession\" pour \"Docteur.\" Devinez les lettres intelligemment, mais trop de fautes mettent fin au jeu ! Besoin d'aide ? Utilisez le bouton d'indice pour un indice. Idéal pour tous les âges, ce puzzle ludique et éducatif vous gardera amusé tout en affûtant vos compétences en orthographe. Pouvez-vous les résoudre tous ?",
      "instructions": "Utilisez une souris ou un pavé tactile pour appuyer sur les lettres, devinez les mots et remplissez les espaces pour compléter le mot.",
      "genres": [
        "Éducatif",
        "Puzzle"
      ],
      "tags": [
        "Échafourne",
        "orthographe",
        "réflexion",
        "questions-réponses",
        "Motscapes"
      ]
    }
  }
};
